module.exports = __webpack_public_path__ + "static/media/dao.fc5f9712.jpg";